// extracted by mini-css-extract-plugin
export default {"melodyVideo":"dR-z","isFullWidth":"eR-z","landingPageVideo":"fR-z","play":"gR-z","iframeVideo":"hR-z","playHidden":"iR-z","fullwidth":"jR-z"};